import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateExecutorPenaltyDataState,
	globalStateExecutorPenaltyDataReducer,
	globalStateExecutorPenaltyDataAction,
} from "./data";

export type StateExecutorPenalty = {
	data: globalStateExecutorPenaltyDataState;
};

export const executorPenalty = combineReducers<StateExecutorPenalty>({
	data: globalStateExecutorPenaltyDataReducer,
});

export const globalStateExecutorPenaltyAction = {
	data: globalStateExecutorPenaltyDataAction,
};

export default executorPenalty;
